import { data } from '../../svg/ThumbUp/data';
import { makeIcon } from '../makeIcon';

export const ThumbUp = makeIcon(data, 'thumb_up', 'ThumbUp');

export default ThumbUp;
